export default {
  title: 'Websites',
  description: 'Cadastre os sites gerenciados pela plataforma e configure domínio, idiomas, tema, modelos visuais, rastreamento e SEO.',
  labels: {
    new: 'Novo Website',
    source: 'Disponíveis',
  },
  form:{
    title: 'Cadastro de Website'
  },
  groups: {
    generalData: 'Dados Gerais',
    theme: 'Tema',
    tracking: 'Rastreamento',
    layouts: 'Layouts',
    language: 'Idioma'
  },
  fields: {
    article_layout: 'Artigo',
    blog_layout: 'Blog',
    choice_file: 'Escolher arquivo',
    client: 'Cliente',
    default_language: 'Idioma Padrão',
    timezone: 'Fuso horário',
    default_route_key: 'Rota Padrão',
    favicon: 'Favicon',
    font_title: 'Fonte de título',
    font_body: 'Fonte de corpo',
    font_size: 'Tamanho da fonte',
    footer_layout: 'Rodapé',
    google_analytics: 'Google Analytics',
    google_tag_manager: 'Google Tag Manager',
    header_layout: 'Cabeçalho',
    logo: 'Logo',
    footer_logo: 'Logo (Rodapé)',
    max_depth: 'Limite de itens',
    ms_clarity: 'Microsoft Clarity',
    plan: 'Plano',
    product: 'Produto',
    product_layout: 'Descrição do produto',
    products_layout: 'Lista de produtos',
    service_layout: 'Descrição do serviço',
    services_layout: 'Lista de serviços',
    status: 'Status',
    supported_languages: 'Idiomas Suportados',
    theme_can_change: 'Permitido alterar tema',
    theme_dark: 'Tema Escuro',
    theme_light: 'Tema Claro',
    theme_loader_dark: 'Loader Escuro',
    theme_loader_light: 'Loader Claro',
    theme_loader_type: 'Tipo do Loader',
    theme_mode: 'Modo do Tema',
    light_bullet: 'Bullet - tema claro',
    light_feature_bullet: 'Bullet destaque - tema claro',
    dark_bullet: 'Bullet - tema escuro',
    dark_feature_bullet: 'Bullet destaque - tema escuro',
    url: 'URL',
    url_preview: 'Subdomínio de Preview',
    whatsapp_string: 'Frase do WhatsApp'
  },
  seo: {
    action: 'Analisar SEO',
    title: 'SEO',
    saveFailed: 'Não foi possível salvar antes da análise SEO.',
    analysisFailed: 'Não foi possível concluir a análise SEO.',
    empty: 'Nenhum problema relevante encontrado.',
    fixLabel: 'Corrigir',
    labels: {
      status: 'Status',
      score: 'Score',
      site: 'Site',
      critical: 'críticos',
      warning: 'alertas',
      info: 'informativos',
    },
    severity: {
      critical: 'Crítico',
      warning: 'Atenção',
      info: 'Info',
    },
    status: {
      good: 'Bom',
      great: 'Ótimo',
      excellent: 'Excelente',
      attention: 'Atenção',
      critical: 'Crítico',
    },
    categories: {
      base: 'Base',
      url: 'URL',
      robots: 'Robots',
      sitemap: 'Sitemap',
      opengraph: 'OpenGraph',
      x: 'X / Twitter',
      schema: 'Schema',
      organizacao: 'Organização',
    },
    issues: {
      titleMissing: { title: 'Título SEO ausente', message: 'O site não possui seo_title preenchido.', recommendation: 'Defina o título base do site.' },
      titleLength: { title: 'Tamanho do título fora do ideal', message: 'O título tem {length} caracteres.', recommendation: 'Busque algo entre 15 e 65 caracteres.' },
      descriptionMissing: { title: 'Descrição SEO ausente', message: 'O site não possui seo_default_description preenchida.', recommendation: 'Defina uma descrição padrão para páginas sem descrição específica.' },
      descriptionLength: { title: 'Tamanho da descrição fora do ideal', message: 'A descrição tem {length} caracteres.', recommendation: 'Busque algo entre 70 e 170 caracteres úteis.' },
      canonicalMissing: { title: 'Canonical base ausente', message: 'O campo seo_canonical_base_url não está preenchido.', recommendation: 'Informe a URL canonical base do site.' },
      canonicalInvalid: { title: 'Canonical inválido', message: 'A URL canonical precisa iniciar com http:// ou https://.', recommendation: 'Use uma URL absoluta.' },
      canonicalHttp: { title: 'HTTPS forçado com canonical HTTP', message: 'O site força HTTPS, mas a canonical base usa HTTP.', recommendation: 'Troque a canonical para https://.' },
      robotsIndexDisabled: { title: 'Indexação desativada', message: 'seo_robots_index está desativado.', recommendation: 'Ative a indexação se o site deve aparecer nos buscadores.' },
      robotsFollowDisabled: { title: 'Follow desativado', message: 'seo_robots_follow está desativado.', recommendation: 'Ative follow para permitir rastreamento de links internos.' },
      sitemapDisabled: { title: 'Sitemap desativado', message: 'seo_sitemap_enabled está desativado.', recommendation: 'Ative o sitemap para facilitar descoberta de páginas.' },
      ogSiteNameMissing: { title: 'Nome do site ausente', message: 'seo_og_site_name não está preenchido.', recommendation: 'Preencha o nome usado em compartilhamentos.' },
      ogTitleMissing: { title: 'Título OpenGraph ausente', message: 'Não há título resolvido para OpenGraph.', recommendation: 'Preencha seo_og_title ou seo_title.' },
      ogDescriptionMissing: { title: 'Descrição OpenGraph ausente', message: 'Não há descrição resolvida para OpenGraph.', recommendation: 'Preencha seo_og_description ou seo_default_description.' },
      ogImageMissing: { title: 'Imagem OpenGraph ausente', message: 'seo_og_image não está preenchida.', recommendation: 'Defina uma imagem padrão de compartilhamento.' },
      ogImageAltMissing: { title: 'Alt da imagem OpenGraph ausente', message: 'seo_og_image_alt não está preenchido.', recommendation: 'Descreva a imagem para acessibilidade e contexto.' },
      twitterCardMissing: { title: 'Card X ausente', message: 'seo_twitter_card não está preenchido.', recommendation: 'Defina summary ou summary_large_image.' },
      twitterTitleMissing: { title: 'Título X ausente', message: 'Não há título resolvido para X/Twitter.', recommendation: 'Preencha seo_twitter_title, seo_og_title ou seo_title.' },
      twitterDescriptionMissing: { title: 'Descrição X ausente', message: 'Não há descrição resolvida para X/Twitter.', recommendation: 'Preencha seo_twitter_description, seo_og_description ou seo_default_description.' },
      twitterImageMissing: { title: 'Imagem X ausente', message: 'Não há imagem resolvida para X/Twitter.', recommendation: 'Preencha seo_twitter_image ou seo_og_image.' },
      twitterImageAltMissing: { title: 'Alt da imagem X ausente', message: 'seo_twitter_image_alt não está preenchido.', recommendation: 'Descreva a imagem para acessibilidade e contexto.' },
      schemaTypeMissing: { title: 'Tipo de schema ausente', message: 'seo_schema_type não está preenchido.', recommendation: 'Defina WebSite, Organization ou outro tipo válido.' },
      schemaJsonInvalid: { title: 'Schema JSON ausente ou inválido', message: 'seo_schema_enabled está ativo, mas o JSON não foi informado ou não é válido.', recommendation: 'Preencha um JSON-LD válido.' },
      organizationNameMissing: { title: 'Nome da organização ausente', message: 'seo_organization_name não está preenchido.', recommendation: 'Informe o nome da marca ou empresa.' },
      organizationUrlMissing: { title: 'URL da organização ausente', message: 'seo_organization_url não está preenchido.', recommendation: 'Informe a URL oficial da organização.' },
      organizationLogoMissing: { title: 'Logo da organização ausente', message: 'seo_organization_logo não está preenchido.', recommendation: 'Defina um logo para schema Organization.' },
      organizationDescriptionMissing: { title: 'Descrição da organização ausente', message: 'seo_organization_description não está preenchida.', recommendation: 'Preencha uma descrição curta da organização.' },
      organizationSameAsMissing: { title: 'Perfis sociais ausentes', message: 'seo_organization_same_as não está preenchido.', recommendation: 'Informe URLs sociais relevantes para sameAs.' },
    },
  }
};
